import { render, staticRenderFns } from "./CompaniesList.vue?vue&type=template&id=ea7fb852&scoped=true"
import script from "./CompaniesList.vue?vue&type=script&lang=js"
export * from "./CompaniesList.vue?vue&type=script&lang=js"
import style0 from "./CompaniesList.vue?vue&type=style&index=0&id=ea7fb852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7fb852",
  null
  
)

export default component.exports